import { HeadHeartIcon } from './HeadHeartIcon';

/**
 * author: Michael Irigoyen
 * id 619BBE2E-46B1-4FC8-91CF-13FE138FC601
 * name head-heart
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-heart.svg
 * tags
 */
export const HeadLoveIcon = HeadHeartIcon;
export default HeadLoveIcon